function initQuantitySync() {
  // Har product-form-component ke liye alag se sync setup karein
  document.querySelectorAll('product-form-component').forEach((productForm) => {
    const section = productForm.closest('.shopify-section') || document;

    const allSelectors = section.querySelectorAll('quantity-selector-component');
    if (allSelectors.length < 2) return; // sync ki zaroorat nahi agar sirf ek hi hai

    let isSyncing = false;

    allSelectors.forEach((selector) => {
      const input = selector.querySelector('input[name="quantity"]');
      if (!input) return;

      const syncOthers = () => {
        if (isSyncing) return;
        isSyncing = true;

        const newValue = selector.getValue ? selector.getValue() : input.value;

        allSelectors.forEach((other) => {
          if (other === selector) return;
          if (other.setValue) {
            other.setValue(newValue);
          }
          if (other.updateButtonStates) {
            other.updateButtonStates();
          }
        });

        isSyncing = false;
      };

      // Typing, blur, aur +/- button click - teeno cases cover karein
      input.addEventListener('input', syncOthers);
      input.addEventListener('blur', syncOthers);

      selector.querySelectorAll('button[name="minus"], button[name="plus"]').forEach((btn) => {
        btn.addEventListener('click', () => {
          // Component apna internal value update karta hai click ke turant baad,
          // isliye microtask delay dekar naye value ko read karte hain
          setTimeout(syncOthers, 0);
        });
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantitySync);
} else {
  initQuantitySync();
}